module.exports = __webpack_public_path__ + "img/pink_cloud_left.8ebd958e.svg";